// extracted by mini-css-extract-plugin
module.exports = {"container":"eventGrid_container__PvJnQ","card":"eventGrid_card__5Fi4I","smallCard":"eventGrid_smallCard__16loS"};